<div class="help-topics-container">
  <div class="text-3xl semi-bold title-label d-flex justify-content-md-between 
  justify-content-lg-between">
  <div class="container-fluid p-0">
    <div class="row">
      <div [ngClass]="country === 'us' ? 'col-xs-12 col-sm-4 col-md-8 how-can-help' : 'col-xs-12 col-sm-6 how-can-help'">
        {{"howCanweHelpYou" | translate }}
      </div>
      
      <div [ngClass]="country === 'us' ? 'col-xs-12 col-sm-8 col-md-4 app-search-bar' : 'col-xs-12 col-sm-6'">
        <!-- <app-search-bar-us *ngIf="country === 'us'; else defaultSearch"></app-search-bar-us>
        <ng-template #defaultSearch> -->
          <app-search-bar></app-search-bar>
        <!-- </ng-template> -->
      </div>
      <div class="col-xs-12 col-sm-6 how-can-help-mobile">{{"howCanweHelpYou" | translate }}</div>
    </div>
  </div>
  </div>
  <div class="displayhide">
    <div class="d-flex flex-column flex-sm-row help-topics align-items-stretch justify-content-sm-around" [ngClass]="country">
      <div class="col-md help-topic justify-content-center d-flex text-xl  text-md align-items-center "
        *ngFor="let fList of featureList; let i = index">
            <a *ngIf="hoverableFeatureList" class="tooltip-tile" (click)="redirectTo(fList)" (mouseover)="fList.hover=true" (mouseout)="fList.hover=false">
              <img class="feature-icon" [src]="icons[i]" [height]="iconCSS?.height" [width]="iconCSS?.width" alt="feature list icons" />
              <span class="text-color" *ngIf="!fList.hover">{{fList?.FL_Label}}</span>
              <span class="text-color" *ngIf="fList.hover">{{fList?.FL_Name}}</span>
            </a>
            <a *ngIf="!hoverableFeatureList" class="tooltip-tile" (click)="redirectTo(fList)">
              <img class="feature-icon" [src]="icons[i]" [height]="iconCSS?.height" [width]="iconCSS?.width" alt="feature list icons" />
              <span class="text-color">{{fList?.FL_Name}}<img height="24" width="24"
                src="../../../../assets/images/feature/angle-right-solid.png" alt="arrow" /></span>
            </a>
      </div>
    </div>
  </div>
  <div *ngIf="hoverableFeatureList && featureList?.length >= 4" class="displayhideindestops">
    <div class="d-flex flex-row help-topics align-items-stretch justify-content-between m-b-0">
      <div class="justify-content-center d-flex text-xl help-topic text-md align-items-center"
      *ngFor="let fList of featureList?.slice(0, 2); let i = index">
          <span class="tooltip-tile">
          <a class="tooltip-tile" (click)="redirectTo(fList)">
            <!-- <img class="feature-icon" [src]="icons[getIconIndex(featureList, fList)]" height="24" width="24" alt="feature list icons" /> -->
             <span class="text-color">{{fList?.FL_Name}}</span>
        </a></span>
      </div>
    </div>
    <div class="d-flex flex-row help-topics align-items-stretch justify-content-between">
      <div class="justify-content-center d-flex text-xl help-topic text-md align-items-center"
      *ngFor="let fList of featureList?.slice(2, 4); let i = index">
          <span class="tooltip-tile">
          <a class="tooltip-tile" (click)="redirectTo(fList)">
            <!-- <img class="feature-icon" [src]="icons[getIconIndex(featureList, fList)]" height="24" width="24" alt="feature list icons" /> -->
             <span class="text-color">{{fList?.FL_Name}}</span>
        </a></span>
      </div>
    </div>
  </div>
  <div *ngIf="!hoverableFeatureList || featureList?.length < 4" class="displayhideindestops">
    <div class="d-flex flex-row help-topics align-items-stretch justify-content-between">
      <div class="justify-content-center d-flex text-xl help-topic text-md align-items-center"
        *ngFor="let fList of featureList?.slice(0,3); let i = index">
          <span class="tooltip-tile">
          <a class="tooltip-tile" (click)="redirectTo(fList)">
            <!-- <img class="feature-icon" [src]="icons[i]" height="32" width="32" alt="feature list icons" /> -->
             <span class="text-color">{{fList?.FL_Name}}</span>
        </a></span>
      </div>
    </div>
  </div>
</div>
